// extracted by mini-css-extract-plugin
export var discard = "_3p-3";
export var muiTooltipTooltip = "_3p-5";
export var notificationBar = "_3p-2";
export var saveButtonHoverSlotWrapper = "_3p-4";
export var show = "_3p-1";
export var spacer = "_3p-0";